import { render } from "./ConversationTranscript.vue?vue&type=template&id=2894f8fe&scoped=true"
import script from "./ConversationTranscript.vue?vue&type=script&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=2894f8fe&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2894f8fe"]])

export default __exports__